import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["globalPercent", "inPlace"]

  applyGlobalPercentage(event) {
    event.preventDefault()

    const percent = this.normalizedPercent(this.globalPercentTarget?.value)
    if (!Number.isFinite(percent)) return

    this.inPlaceTargets.forEach((input) => {
      const scheduledValue = parseFloat(input.dataset.scheduledValue || "0")
      if (!Number.isFinite(scheduledValue)) return

      input.value = this.roundCurrency(scheduledValue * percent)
    })
  }

  normalizedPercent(rawValue) {
    const value = parseFloat(rawValue)
    if (!Number.isFinite(value)) return NaN

    return value > 1 ? value / 100 : value
  }

  roundCurrency(value) {
    return (Math.round(value * 100) / 100).toFixed(2)
  }
}
